var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('a',{attrs:{"href":'tel:' + _vm.tel}},[_vm._v(_vm._s(_vm.tel))]):_c('a',[_vm._v(_vm._s(_vm.tel))])}
var staticRenderFns = []

export { render, staticRenderFns }